import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ImportBatchDto, ImportBatchStatus, ImportErrorDto, ImportType } from './models/import.model';

export interface ImportBatchPageDto {
  items: ImportBatchDto[];
}

@Injectable()
export abstract class ImportService {
  abstract getBatches(status?: ImportBatchStatus): Observable<ImportBatchPageDto>;
  abstract getBatch(batchId: string): Observable<ImportBatchDto>;
  getRejections(batchId: string): Observable<ImportErrorDto[]> { return throwError(() => new Error(`Import rejections API unavailable for ${batchId}`)); }
  upload(file: File, importType: ImportType): Observable<ImportBatchDto> { return throwError(() => new Error(`Import upload API unavailable for ${importType}`)); }
}
